
// example input
// [{
//     "no": 1,
//     "name": "Jhiro Faran",
//     "q1y2": 0,
//     "q2y2": 0,
//     "q3y2": 0,
//     "q4y2": 0,
//     "q1y1": 0,
//     "q2y1": 0,
//     "q3y1": 2,
//     "q4y1": 0,
//     "q1y": 0,
//     "q2y": 1,
//     "q3y": 0,
//     "q4y": 0
//   }]

function transformChartData(input, tableConfig) {
  if (!input?.length) {
    return { data: [], dataKey: [] };
  }


  const labelMap = {};
  tableConfig.forEach(col => {
    labelMap[col.name] = col.label;
  });

  const quarterKeys = Object.keys(input[0]).filter(
    key => key !== "name" && key !== "no"
  );

  const employeeNames = input
    .map(entry => entry.name)
    .filter(name => name !== "TOTAL");

  const chartData = quarterKeys.map(quarter => {
    const row = {
      division: labelMap[quarter] || quarter
    };

    input.forEach(entry => {
      if (entry.name !== "TOTAL") {
        row[entry.name] = entry[quarter];
      }
    });

    return row;
  });

  const colorPalette = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#a0522d"];

  const dataKey = employeeNames.map((name, index) => ({
    key: name,
    color: colorPalette[index % colorPalette.length]
  }));

  return {
    data: chartData,
    dataKey
  };
}

export const service = {
  transformChartData
};
